import React from "react";
import SwiperCore, { SwiperOptions, Autoplay, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";

type DataType = {
  name: string;
  value: number;
};

interface ScrollListProps {
  data: DataType[];
  process?: boolean;
}

SwiperCore.use([Autoplay, Mousewheel]);

const swiperParams: SwiperOptions = {
  direction: "vertical",
  loop: true,
  loopedSlides: 5,
  slidesPerView: "auto",
  mousewheel: true,
  autoplay: {
    delay: 1800,
    disableOnInteraction: false,
  },
};

const ScrollList: React.FC<ScrollListProps> = ({ data, process = false }) => {
  return (
    <Swiper
      className="h-full w-full"
      style={{ position: "absolute", left: "4%", width: "92%", height: "100%" }}
      {...swiperParams}
      onSwiper={(swiper) => setTimeout(() => swiper.update(), 2000)}
    >
      {data
        ?.filter(({ name }) => !/其他|其它|N\/A/.test(name))
        ?.map(({ name, value }, i) => (
          <SwiperSlide
            key={name}
            className="flex justify-between items-center"
            style={{
              borderBottom: "1px solid #353ca5",
              height: "20%",
            }}
          >
            {!process && (
              <span
                className="flex-none w-2 h-2 rounded-full mx-3"
                style={{
                  backgroundColor: "#7cc3fa",
                }}
              ></span>
            )}
            <span className="inline flex-auto text-base font-s">
              NO.{i + 1} {name}
            </span>
            <span className="inline flex-none text-xl font-n">
              {value.toLocaleString()}
            </span>
            {process && (
              <div
                className="absolute left-0 h-1"
                style={{
                  bottom: "0.15625vw",
                  backgroundImage:
                    "linear-gradient(to right, #4f85db, #f4e1ff)",
                  width: `${
                    (value / Math.max(...data.map((v) => v.value))) * 66.67
                  }%`,
                }}
              ></div>
            )}
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export default ScrollList;
